const id_ID = {
  restartInterviewButton: 'Mulai ulang',
  restartInterviewConfirmTitle: 'Mulai wawancara baru?',
  restartInterviewConfirmDescription: 'Wawancara baru akan dimulai dari awal. Catatan wawancara sebelumnya tetap disimpan.',
  restartInterviewCancel: 'Batal',
  restartInterviewFailed: 'Tidak dapat memulai ulang wawancara. Silakan coba lagi nanti.',
  restartInterviewLimitReached: 'Batas wawancara telah tercapai. Anda tidak dapat memulai wawancara baru.',
  restartInterviewClosed: 'Wawancara ini telah ditutup. Anda tidak dapat memulai wawancara baru.',
  restartInterviewCutoff: 'Batas waktu wawancara telah berlalu. Anda tidak dapat memulai wawancara baru.',
  interviewLoading: 'Memuat wawancara…',
  interviewLinkInvalid: 'Tautan wawancara tidak valid',
  interviewLoadFailed: 'Tidak dapat memuat wawancara. Silakan coba lagi nanti.',
  interviewRetry: 'Coba lagi',
  saveInfoFailed: 'Gagal menyimpan informasi Anda. Silakan coba lagi.',
  loadLatestInterviewFailed: 'Tidak dapat memuat catatan wawancara terbaru. Silakan coba lagi nanti.',
  interviewProgressSaved: 'Progres wawancara Anda tidak akan hilang',
  previousStimulus: 'Konsep sebelumnya',
  nextStimulus: 'Konsep berikutnya',
  expandStimulus: 'Perbesar konsep',
  closeStimulusPreview: 'Tutup pratinjau konsep',
  stimulusPreview: 'Pratinjau konsep',
  imageTooLarge: 'Ukuran gambar tidak boleh melebihi 10 MB',
  imageFormatJpegPngOnly: 'Hanya gambar PNG dan JPEG yang didukung',
  imageFilesOnly: 'Hanya berkas gambar yang dapat diunggah',
  imageUploadFailed: 'Gagal mengunggah gambar. Silakan coba lagi.',
  finalUploadFailed: 'Gagal mengunggah berkas. Silakan coba lagi.',
  Welcome: 'Selamat datang di wawancara untuk',
  StartInterview: 'Mulai wawancara',
  Submit: 'Kirim',
  Stoprecording: 'Hentikan rekaman',
  Aiinterviewer: 'PEWAWANCARA AI',
  AiModeratedInterview: 'WAWANCARA DIPANDU AI',
  TalkToAva: 'Bicara dengan Ava',
  microphoneAccessTitle: 'Izinkan akses mikrofon',
  microphoneAccessDescription: 'Ava memerlukan mikrofon Anda agar percakapan suara berjalan lancar.',
  microphoneAllow: 'Izinkan mikrofon',
  microphoneNotNow: 'Nanti saja',
  microphoneConnectedTitle: 'Mikrofon terhubung',
  microphoneConnectedDescription: 'Semua siap. Ava siap mendengarkan.',
  microphoneDeniedTitle: 'Akses mikrofon diperlukan',
  microphoneDeniedDescription: 'Izinkan akses mikrofon di pengaturan browser Anda, lalu coba lagi.',
  microphoneTryAgain: 'Coba lagi',
  VoiceAnswer: 'Jawaban suara',
  TextAnswer: 'Jawaban teks',
  StudyMainTitle: 'Sebelum wawancara, kami akan melakukan penyaringan singkat',
  StudyMainTip: 'Maaf, Anda tidak termasuk kelompok sasaran wawancara ini dan tidak dapat berpartisipasi',
  TitleTop: 'ANDA DIUNDANG!',
  HeardVoice: 'SUARAKAN PENDAPAT ANDA DAN DAPATKAN HADIAH',
  Sophie: 'Obrolan santai 5–10 menit bersama Ava',
  Sponsored: 'Disponsori oleh Sinterklas🎅',
  Chikkens: 'Mulai obrolan singkat dan dapatkan hadiah',
  Dollars: 'dengan CHIMOJI unik Anda',
  Congrats: 'SELAMAT!',
  ThankYou: 'Terima kasih atas pendapat Anda',
  Identity: 'Pilih identitas Anda',
  Refresh: 'Memuat ulang halaman tidak akan menghapus progres percakapan ini',
  Carousel: 'Sedikit keterlambatan mungkin terjadi karena kondisi jaringan',
  CheckOut: 'Ingin membuat wawancara seperti ini? Lihat ',
  Rewarded: 'Jika ingin menerima hadiah, pewawancara memerlukan informasi Anda ',
  InterviewerReward: 'Ini hadiah dari pewawancara Anda ',
  Register: 'Daftar atau masuk sebagai',
  Insighteer: 'INSIGHTEER',
  Reward: 'untuk menerima hadiah Anda',
  CreatePassword: 'dengan membuat kata sandi untuk menyelesaikan pendaftaran',
  Becoming: 'Menjadi',
  Password: 'Masukkan kata sandi Anda!',
  ChooseTopic: 'Pilih topik yang menarik bagi Anda',
  Awesome: 'Luar biasa!',
  Rocks: 'HEBAT',
  Followus: 'Ikuti kami',
  Unique: 'CHIMOJI unik ini dibuat dari percakapan Anda sebagai NFT di blockchain',
  Next: 'LANJUT',
  ViewRewards: 'LIHAT HADIAH',
  endMeg1: 'Tinggalkan alamat email Anda agar kami dapat mengirimkan rekaman suara',
  endMeg2: 'Tinggalkan informasi Anda untuk menerima insentif dari pembuat wawancara ini',
  endMeg3: 'Tinggalkan informasi Anda untuk pembuat wawancara ini',
  endMsg5: 'Tinggalkan informasi Anda untuk menerima ',
  endMsg6: 'hasil tes MBTI Anda',
  Done: 'SELESAI',
  Done1: 'SELESAI',
  GetIncentives: 'DAPATKAN INSENTIF',
  GetStartedFreeNow: 'Mulai gratis sekarang',
  UniqueChimojiNFT: 'NFT CHIMOJI unik',
  endMsg4: 'Ingin membuat wawancara Anda sendiri?',
  ResumeInterview: 'Klik untuk melanjutkan wawancara',
  interviewPausedTitle: 'Wawancara dijeda',
  interviewPausedDescription: 'Progres Anda telah disimpan. Anda dapat melanjutkannya kapan saja.',
  resumeInterviewButton: 'Lanjutkan wawancara',
  pauseInterview: 'Jeda',
  pauseInterviewConfirmTitle: 'Jeda wawancara?',
  pauseInterviewConfirmContent: 'Progres Anda akan disimpan. Anda dapat melanjutkan wawancara nanti.',
  pauseInterviewConfirmOk: 'Jeda',
  pauseInterviewConfirmCancel: 'Lanjutkan wawancara',
  poorConnection: 'Koneksi lemah',
  connectionReconnectingTitle: 'Menghubungkan kembali…',
  connectionReconnectingDescription: 'Biarkan halaman ini tetap terbuka. Ava sedang memulihkan koneksi Anda.',
  connectionReconnectedTitle: 'Terhubung kembali',
  connectionReconnectedDescription: 'Anda kembali online. Wawancara dilanjutkan.',
  connectionDisconnectedTitle: 'Koneksi terputus',
  connectionDisconnectedDescription: 'Progres wawancara Anda telah disimpan.',
  refresh: 'Memuat ulang halaman tidak akan menghapus progres Anda',
  voiceSnapshot: 'Cuplikan suara',
  fromInterview: 'Dari wawancara saya bersama Ava, kurator cerita AI',
  findMore: 'Cari tahu lebih lanjut di Chikka.ai',
  msg1: 'KETAHUI MBTI ANDA DALAM 5 MENIT DENGAN BERBICARA BERSAMA AVA',
  speaking: 'Anda sedang berbicara…',
  avaSpeaking: 'Ava sedang berbicara…',
  avaListening: 'Ava sedang mendengarkan…',
  stimuliConversationWithAva: 'Anda sedang berbincang dengan Ava',
  stimuliReviewConcepts: 'Perhatikan konsep di bawah ini dan jawab pertanyaan Ava.',
  stimuliSwipeInstruction: 'Geser ke kiri atau kanan untuk melihat semua konsep.',
  stimuliFullscreenInstruction: 'Klik dua kali gambar untuk melihatnya dalam layar penuh.',
  finalUploadTitleFallback: 'Unggah berkas',
  finalUploadInstructionFallback: 'Tambahkan berkas sebelum mengakhiri wawancara',
  finalUploadTap: 'Ketuk untuk mengunggah',
  finalUploadHelp: 'Berkas Anda membantu kami memahami pengalaman Anda dengan lebih baik.',
  finalUploadLimit: 'Maksimal 10 berkas',
  finalUploadSubmit: 'KIRIM',
  finalUploadSkip: 'Lewati',
  finalUploadWait: 'Harap tunggu hingga semua berkas selesai diunggah',
}

export default id_ID
